/**
 * Diccionario y algoritmo de humanización de nombres de tools.
 * Inspirado en Kuadre IA. Convierte snake_case → texto natural en español.
 */

const DICT: Record<string, string> = {
  // Productores
  buscar_productor: "Buscando productores",
  ver_productor: "Cargando detalle del productor",
  crear_productor: "Creando productor",
  actualizar_productor: "Actualizando productor",

  // Órdenes
  buscar_oa: "Buscando órdenes",
  ver_oa: "Cargando detalle de la OA",
  confirmar_preorden: "Confirmando pre-orden",
  marcar_oa_emergencia: "Marcando emergencia",

  // Siembras
  buscar_siembra: "Buscando siembras",

  // Recepción
  buscar_recepcion: "Buscando recepciones",
  ver_recepcion: "Cargando detalle de recepción",

  // Logística
  buscar_viaje: "Buscando viajes",
  ver_viaje: "Cargando detalle del viaje",

  // Acuerdos
  buscar_acuerdo: "Buscando acuerdos",
  ver_acuerdo: "Cargando detalle del acuerdo",

  // Ayuda
  consultar_glosario: "Consultando glosario",

  // Parse
  parse_filters: "Interpretando consulta",
};

/**
 * Convierte un nombre de tool en una etiqueta legible en español.
 * Si está en el diccionario, usa esa traducción.
 * Si no, hace fallback inteligente: snake_case → "Snake case" capitalizado.
 */
export function humanizeTool(toolName: string): string {
  if (!toolName) return "Herramienta";
  if (DICT[toolName]) return DICT[toolName];
  // Fallback: convertir snake_case a "Capitalized words"
  const parts = toolName.split("_").filter(Boolean);
  if (parts.length === 0) return toolName;
  const first = parts[0].charAt(0).toUpperCase() + parts[0].slice(1);
  const rest = parts.slice(1).join(" ").toLowerCase();
  return rest ? `${first} ${rest}` : first;
}

/** Formato compacto de duración: "1.2s" o "240ms". */
export function formatDuration(ms: number): string {
  if (!Number.isFinite(ms) || ms < 0) return "";
  if (ms >= 1000) return `${(ms / 1000).toFixed(1)}s`;
  return `${Math.round(ms)}ms`;
}
